import { type } from '../actions/type';


const INITIAL_STATE = {
    name: null,
    email: null,
    tokenId: null,
    accessToken: null
}

const authReducer = (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case type.LOGIN:

            return { ...state, tokenId: action.payload.tokenId, name: action.payload.name,email: action.payload.email, accessToken: action.payload.accessToken, expiry: action.payload.expiry };

        case type.LOGOUT:
            return { ...state, tokenId:null,name:null,email:null,accessToken:null,expiry:null }

        default:
            return state;
    }
}
export default authReducer;